import { useMemo } from "react";
import type { BreadcrumbItem } from "@legal-500/legal500-design-system";
import type { HierarchicalItem } from "../../../types/uiTypes";

export function useBreadcrumbs<T extends HierarchicalItem>(
  treeData: T[],
  selectedId: string | null,
  data: T[] | undefined,
) {
  const breadcrumbs = useMemo(() => {
    if (!selectedId || !data) {
      return [];
    }

    const findPath = (
      itemList: T[],
      targetId: string,
      path: BreadcrumbItem[] = [],
    ): BreadcrumbItem[] | null => {
      for (const item of itemList) {
        const newPath = [...path, { id: item.id, name: item.name }];
        if (item.id === targetId) {
          return newPath;
        }
        if (item.children) {
          const result = findPath(item.children as T[], targetId, newPath);
          if (result) return result;
        }
      }
      return null;
    };

    const path = findPath(treeData, selectedId);
    return path || [];
  }, [selectedId, data?.length, treeData?.length]);

  return breadcrumbs;
}
